export const BoxIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 56 56">
		<path
			stroke="#14489D"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M45.5 7h-35A3.5 3.5 0 0 0 7 10.5v35a3.5 3.5 0 0 0 3.5 3.5h35a3.5 3.5 0 0 0 3.5-3.5v-35A3.5 3.5 0 0 0 45.5 7Z"
		/>
		<path
			fill="#F0F6FF"
			stroke="#14489D"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M45.5 7h-35C8.567 7 7 7.435 7 7.972v9.723c0 .536 1.567.972 3.5.972h35c1.933 0 3.5-.436 3.5-.973V7.973C49 7.435 47.433 7 45.5 7Z"
		/>
		<path
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M7 18.667h42M23.333 37.334 28 32.667l4.666 4.667M7 11.667v14m42-14v14"
		/>
	</svg>
);

export const ApplicationsIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56">
		<path
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M39.667 11.667 49 21m0-9.333L39.667 21m11.666 14-8.166 9.333-4.667-4.666"
		/>
		<path
			fill="#F0F6FF"
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M29.173 13H3.506v9.333h25.667V13Zm1.161 22H4.667v9.333h25.667V35Z"
		/>
	</svg>
);

export const DocumentIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56">
		<path
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M44.332 4.667H11.665A2.333 2.333 0 0 0 9.332 7v42a2.333 2.333 0 0 0 2.333 2.334h32.667A2.333 2.333 0 0 0 46.665 49V7a2.333 2.333 0 0 0-2.333-2.333ZM19.832 35h16.333m-16.333 7h8.167"
		/>
		<path
			stroke="#14489D"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="4"
			d="M35 15.167 25.667 24.5 21 19.834"
		/>
	</svg>
);
